import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaInstagram, FaYoutube } from 'react-icons/fa';

const ContactUsSection = () => {
    return (
        <section className="contact-section" id="contact-us">
            <div
                className="contact-cta"
                style={{
                    backgroundImage: `linear-gradient(90deg, rgba(17, 24, 39, 0.88), rgba(17, 24, 39, 0.62)), url(${process.env.PUBLIC_URL}/projects/11/1.jpeg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="container reveal">
                    <h2>Ready to discuss your facade?</h2>
                    <p>Talk to the Sona Alusys team about glazing, cladding, aluminium, and UPVC work for your project.</p>
                    <div className="hero-actions">
                        <a className="hero-btn is-solid" href="tel:+919555808671">Call +91-9555808671</a>
                        <a className="hero-btn" href="mailto:info@sonaalusys.com">info@sonaalusys.com</a>
                    </div>
                </div>
            </div>
            <div className="container contact-details">
                <p className="eyebrow">Get in touch</p>
                <h2 className="section-title">Contact info</h2>
                <div className="contact-cards">
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaPhoneAlt /></span>
                        <p className="eyebrow">Call for help</p>
                        <a className="contact-value" href="tel:+919555808671">+91-9555808671</a>
                        <a className="contact-value" href="tel:+919211515758">+91-9211515758</a>
                    </article>
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaEnvelope /></span>
                        <p className="eyebrow">Write email</p>
                        <a className="contact-value" href="mailto:info@sonaalusys.com">info@sonaalusys.com</a>
                    </article>
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaMapMarkerAlt /></span>
                        <p className="eyebrow">Visit office</p>
                        <p className="contact-value">
                            Khasra No. 212, Vill. Piplehda, Dasna, Bhoorgarhi Road, Tehsil-Dhaulana, District Hapur, Uttar Pradesh - 201015
                        </p>
                    </article>
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaClock /></span>
                        <p className="eyebrow">Operating hours</p>
                        <p className="contact-value">Monday – Saturday: 9:00 AM – 6:30 PM</p>
                        <p className="contact-note">Estimations reviewed within 24 working hours</p>
                    </article>
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaInstagram /></span>
                        <p className="eyebrow">Instagram</p>
                        <a className="contact-value" href="https://www.instagram.com/sonaalusys/" target="_blank" rel="noreferrer">@sonaalusys</a>
                    </article>
                    <article className="contact-card reveal">
                        <span className="contact-card-icon" aria-hidden="true"><FaYoutube /></span>
                        <p className="eyebrow">YouTube</p>
                        <a className="contact-value" href="https://www.youtube.com/@SonaAlusysIndustries" target="_blank" rel="noreferrer">@SonaAlusysIndustries</a>
                    </article>
                </div>
            </div>
            {/* <div className="container">
                <h2 className="fw-bold ">CONTACT INFO</h2>
                <h6 className="fw-bold mb-4">Get to know us</h6>
                <div className='mb-5 text-center'>
                    CALL FOR HELP
                </div>
            </div> */}
            {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d32185.84618643464!2d77.19682322598821!3d28.617009549668886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2daa9eb4d0b%3A0x717971125923e5d!2sIndia%20Gate!5e0!3m2!1sen!2sin!4v1759222119439!5m2!1sen!2sin"
                style={{
                    height: '60vh',
                    width: '100vw',
                    border: 0
                }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe> */}
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92668.5038321292!2d77.46656252494533!3d28.679434868424806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf3e4812314d1%3A0x4a22ab7099c94316!2sSona%20Alusys%20Industries!5e0!3m2!1sen!2sin!4v1760181522040!5m2!1sen!2sin"
                style={{
                    height: '60vh',
                    width: '100vw',
                    border: 0
                }}
                allowfullscreen=''
                loading="lazy"
            // referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe>

        </section>
    );
}

export default ContactUsSection;
